import store from '@/store'
let hostname = window.location.hostname === 'localhost'

export default function getBaseURL(){
    let baseURL = hostname ? '/api' : `${store.getters.authorityRoute}/api/v1`
    return baseURL
}
